import { useState, useEffect } from "react";
import { gtagLineEvent } from "@/utils/gtag";

const LINE_URL = "https://lin.ee/PLE85Ab";
const GTAG_EVENT = "YAMEBI_1_LINE友達追加_ヘッダー";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-sm py-3" : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-5xl mx-auto px-6 flex items-center justify-between">
        <a href="/" className="flex items-center">
          <img
            src="https://static.readdy.ai/image/b17b44323c7eb3fa784eb391778099fd/364f60d3363b88dfbdfabe6d3242f52a.svg"
            alt="YAMEBI ロゴ"
            className="h-8 w-auto object-contain"
          />
        </a>
        <a
          href={LINE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => { e.preventDefault(); gtagLineEvent(LINE_URL, GTAG_EVENT); }}
          className="whitespace-nowrap flex items-center gap-2 bg-[#00B900] hover:bg-[#009900] text-white text-sm font-bold px-5 py-2 rounded-full transition-colors cursor-pointer"
        >
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-line-fill text-lg"></i>
          </span>
          公式LINEを友だち追加
        </a>
      </div>
    </header>
  );
}
